export const ReportAnAbsencePermission = [
  "absence.submitter",
  "absence.modify"
];

export const CancelAbsencePermission = ["absence.cancel"];

export const ModifySubmittedAbsencePermission = ["myabiliti.absence.modify"];
